export const MEETING_LINK = 'https://meetings.hubspot.com/michael-guerin/8base-agency-intro';
